import { Temporal } from "temporal-polyfill";

/** Matches Beam's DateRange type that we use for filters. */
export type DateRange = { from: Temporal.PlainDate | null | undefined; to?: Temporal.PlainDate | null | undefined };

/** Returns true when a DateRange has both boundaries required for a between filter. */
export function hasCompleteDateRange(
  dateRange: DateRange | null | undefined,
): dateRange is { from: Temporal.PlainDate; to: Temporal.PlainDate } {
  return !!dateRange?.from && !!dateRange.to;
}

export function intervalsOverlap(
  left: { start: Temporal.PlainDate; end: Temporal.PlainDate },
  right: { start: Temporal.PlainDate; end: Temporal.PlainDate },
) {
  return !left.end.isBefore(right.start) && !right.end.isBefore(left.start);
}

export function isWithinDateRange(
  date: Temporal.PlainDate | null | undefined,
  startDate: Temporal.PlainDate | null | undefined,
  endDate: Temporal.PlainDate | null | undefined,
): boolean;
export function isWithinDateRange(
  dateRange: DateRange | undefined,
  date: Temporal.PlainDate | null | undefined,
): boolean;
export function isWithinDateRange(
  dateOrDateRange: Temporal.PlainDate | DateRange | null | undefined,
  startDateOrDate: Temporal.PlainDate | null | undefined,
  endDate?: Temporal.PlainDate | null | undefined,
) {
  if (isDateRange(dateOrDateRange)) {
    return isDateWithinRange(startDateOrDate, dateOrDateRange.from, dateOrDateRange.to);
  }
  return isDateWithinRange(dateOrDateRange, startDateOrDate, endDate);
}

function isDateRange(value: Temporal.PlainDate | DateRange | null | undefined): value is DateRange {
  return !!value && typeof value === "object" && "from" in value;
}

function isDateWithinRange(
  date: Temporal.PlainDate | null | undefined,
  startDate: Temporal.PlainDate | null | undefined,
  endDate: Temporal.PlainDate | null | undefined,
) {
  if (!date || !startDate || !endDate) return false;
  return (date.equals(startDate) || date.isAfter(startDate)) && (date.equals(endDate) || date.isBefore(endDate));
}
